import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/CreateStaffUser.graphql';
import { Mutation, MutationcreateStaffUserArgs } from '../../__generated__/globalTypes';

export const useCreateStaffUserMutation = (options?: MutationHookOptions<Mutation, MutationcreateStaffUserArgs>) => {
  const [callCreateStaffUser, result] = useMutation<Mutation, MutationcreateStaffUserArgs>(MUTATION, options);

  return { callCreateStaffUser, ...result };
};

export type CreateStaffUserMutationFunction = Mutation['createStaffUser'];
